export const ckeditorconfig = {    
	height : '100px',
    width :'65%',
	addCss: '.divImagenConBajada img{width: 100% !important;}',
	toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		'/',
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'Outdent', 'blocks', 'align', 'bidi', 'paragraph','iframe' ,'Anchor'] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
	removeButtons : 'Save,NewPage,Preview,Print,Templates,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Subscript,Superscript,Strike,CopyFormatting,JustifyRight,BidiLtr,BidiRtl,Language,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,FontSize,Font,Maximize,ShowBlocks,About,Intent',
	stylesSet : [
		{ name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
		{ name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
		{ name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
		{ name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
		{ name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
	],
	div_wrapTable : true,
	extraAllowedContent: 'section class iframe style video embed',
	allowedContent : true,
	image: {toolbar: [ 'imageTextAlternative' ]},
	extraPlugins : 'embed, iframe',
	embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
	skin : 'kama'
}